export const faqs = [
  {
    question: 'What exactly is MAXILLARY GROWTH BLUEPRINT™?',
    answer:
      'It’s a digital educational collection consisting of six specialized volumes and five complementary bonuses. The materials cover craniofacial growth, skeletal maturity, maxillomandibular relationships, dentofacial assessment, orthopedic planning principles, and longitudinal growth monitoring.',
  },
  {
    question: 'Who is this collection designed for?',
    answer:
      'It’s intended for dental professionals, orthodontic trainees, and qualified clinicians interested in strengthening their understanding of maxillary growth and dentofacial orthopedics. It is not designed to qualify untrained individuals to perform orthodontic or orthopedic treatment.',
  },
  {
    question: 'Is this a physical book or a digital product?',
    answer: 'This is a 100% digital PDF collection. No physical books are shipped.',
  },
  {
    question: 'How will I receive the materials?',
    answer:
      'The collection is delivered digitally. The exact access instructions are displayed at checkout.',
  },
  {
    question: 'Can I download the materials?',
    answer:
      'Yes. The offer consists of downloadable PDF resources, subject to the delivery and access terms displayed at checkout.',
  },
  {
    question: 'Can I access the collection from any country?',
    answer:
      'The educational materials can be studied internationally. However, professional standards, clinical protocols, regulatory requirements, and accepted treatment practices vary by jurisdiction. Always follow applicable local requirements.',
  },
  {
    question: 'Does this collection teach me to perform orthopedic treatments independently?',
    answer:
      'No. It is an educational reference designed to strengthen conceptual understanding and support structured clinical learning. It does not replace supervised clinical training, specialist education, professional judgment, or individualized patient assessment.',
  },
  {
    question: 'Does it include clinical cases?',
    answer:
      'Yes. The collection includes illustrated educational scenarios and examples demonstrating how different assessment concepts relate to one another. These examples are for learning purposes and are not individualized treatment recommendations.',
  },
  {
    question: 'Are the five bonuses included in the $27 price?',
    answer:
      'Yes. The complete offer includes all six volumes and all five bonuses for a single payment of $27 USD.',
  },
  {
    question: 'Is this a subscription?',
    answer:
      'No. The purchase price is a one-time payment of $27. There are no recurring subscription charges associated with this offer.',
  },
  {
    question: 'Can I use the worksheets in clinical practice?',
    answer:
      'The worksheets are designed as educational and organizational aids. Any use involving actual patient information must comply with applicable privacy requirements, professional standards, and your institution’s documentation policies. They do not replace required clinical records.',
  },
  {
    question: 'Is there a money-back guarantee?',
    answer: 'Please review the refund terms displayed at checkout before completing your purchase.',
  },
];
